import React, { useEffect, useState } from "react";
import { Styles } from "./styles";
import { getAllPartners } from "../../../services/home.service";
import { t } from "i18next";
import { useSelector } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper";
import Loader from "../../common/loader/Loader";
import { Container } from "react-bootstrap";
import { Fade } from "react-reveal";

const OurPartners = () => {
  // language data from store
  const Resource = useSelector((state) => state.translation.resource);

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState();

  const getData = async () => {
    setIsLoading(true);
    const response = await getAllPartners();
    if (response?.status === 200) {
      setData(response?.data?.data?.list);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <Styles dataLength={data?.length}>
      {isLoading ? (
        <Loader />
      ) : (
        data?.length > 0 && (
          <section id="administrativeStaffSection">
            <Container>
              <Fade bottom>
                <h2 className="section-title">
                  {Resource?.our_partners_title
                    ? Resource?.our_partners_title
                    : t("our_partners_title")}
                </h2>
              </Fade>
              <Swiper
                navigation={true}
                modules={[Navigation, Autoplay]}
                loop={true}
                autoplay={{
                  delay: 500,
                  disableOnInteraction: true,
                }}
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                  },
                  576: {
                    slidesPerView: data?.length > 1 ? 2 : 1,
                  },
                  768: {
                    slidesPerView:
                      data?.length > 2 ? 3 : data?.length > 1 ? 2 : 1,
                  },
                  992: {
                    slidesPerView:
                      data?.length > 3
                        ? 4
                        : data?.length > 2
                        ? 3
                        : data?.length > 1
                        ? 2
                        : 1,
                  },
                }}
              >
                {data?.map((item, idx) => {
                  return (
                    <SwiperSlide key={idx}>
                      <a
                        href={item?.websiteUrl}
                        target="_blank"
                        className="img-container"
                      >
                        <img alt={item?.localizedName} src={item?.avatar} />
                        <div className="name">{item?.localizedName}</div>
                      </a>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </Container>
          </section>
        )
      )}
    </Styles>
  );
};

export default OurPartners;
